var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFC627;}\r\n\t.st1{fill:#8B2332;}\r\n\t.st2{fill:#0D2240;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.8,50c40,0,77.7,15.6,106.1,44c28.4,28.4,44,66.1,44,106.1c0,82.8-67.3,150.1-150.1,150.1 c-40.1,0-77.9-15.6-106.2-44c-28.3-28.4-43.9-66.1-43.9-106.2c0-39.9,15.7-77.8,43.9-106.1C122.1,65.6,159.8,50,199.8,50"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.8,338.3c76.1,0,138.1-62,138.1-138.3c0-76.1-62-138.2-138.1-138.2c-76.2,0-138.2,62.1-138.2,138.2 C61.7,276.3,123.7,338.3,199.8,338.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.9,200.1c0-70.4,57.4-127.8,127.9-127.8c70.5-0.1,127.9,57.3,127.9,127.8s-57.3,127.9-127.8,127.9 C129.3,328.1,71.9,270.7,71.9,200.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300.6,146.6l2.8-1.6l-9.2-14.2l-2.5,1.9c-15.6-19.7-43.4-41.7-69.8-45c19.9,9.1,42.3,32.3,55.9,50.2 l-14.4,10.3l1.8,2.6l-64.8,42.1l-64.8-42.1l1.8-2.6L123,137.7c13.7-17.8,36.1-41,55.9-50.2c-26.4,3.3-54.2,25.2-69.7,44.9l-2.7-1.9 l-9.2,14.2l2.8,1.7l-0.1,0.1c-11.4,22.4-19.8,57.1-11.6,82.4c-0.2-21.9,11.6-52,22.1-72.1l15.5,8.8l1.6-2.4l60.2,37.8l-79.4,51.6 l-0.1-0.2l-10.6,2.8l0.1,0.3c-0.5,1.9,0.5,5.7,2.7,9.2c2.2,3.6,5.1,5.9,7.2,6.3l0.2,0.3l7.1-8.6l-0.1-0.2L273.1,163l1.6,2.4 l15.5-8.8c10.5,20.1,22.3,50.2,22.2,72.1C320.5,203.7,312,169,300.6,146.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.4,252.5l-0.1,0.2l-73.1-47.5l-12.8,7.6l79.3,50l-0.1,0.2l7,8.6l0.2-0.3c2.1-0.4,5-2.7,7.2-6.3 c2.2-3.5,3.2-7.2,2.7-9.2l0.1-0.3L292.4,252.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "212.9,100.4 207.4,107.5 199.8,89.4 199.8,173.2 225.3,140.5 251,147.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "212.9,120 212.9,100.4 207.4,107.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "199.8,89.4 153.5,145.9 173.8,140.6 199.8,173.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M172.6,300.8c6.5-6.3,14.9-10.1,24-11v-12.6h-34.6C162.7,286.4,166.5,294.6,172.6,300.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.4,312.4v-14.8c-6.7,0.8-13,3.6-18,8.3C183.8,309.4,189.9,311.7,196.4,312.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M204.1,235.4v14.8c6.7-0.8,13-3.6,18-8.2C216.9,238.4,210.8,236.1,204.1,235.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M228.1,247.1c-6.5,6.2-14.9,10.1-23.9,10.9v11.4h34.6C237.7,260.9,233.8,253,228.1,247.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M196.4,250.2v-14.8c-6.6,0.7-12.8,3-17.9,6.6C183.6,246.6,189.8,249.5,196.4,250.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.1,277.2v12.6c9,0.9,17.3,4.7,23.9,11c6-6.2,10-14.4,10.7-23.6L204.1,277.2L204.1,277.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.9,269.4h34.5V258c-9-0.8-17.3-4.8-24-10.9C166.8,253,162.9,260.9,161.9,269.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.1,312.4c6.6-0.7,12.8-3,18-6.6c-5-4.7-11.3-7.5-18-8.3V312.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDen);
export default __webpack_public_path__ + "static/media/DEN.46c3bc569b6d4e19348db42591dbe549.svg";
export { ForwardRef as ReactComponent };